import React, { FC, useCallback } from 'react'
import clsx from 'clsx'
import { List, ListItem, Button, Link } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { useDispatch } from 'react-redux'
import { navigationTabListHeader, navigationTabListFooter } from './navigationTabList'
import { logoutRequest } from '../../../store/actions'

const useStyles = makeStyles((theme: Theme) => ({
  navHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0,
  },
  navFooter: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0,
  },
  navItem: {
    width: 'auto',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: theme.spacing(2),
  },
  navLink: {
    textDecoration: 'none',
    textTransform: 'none',
    fontWeight: 400,
    color: theme.palette.primary.light,
    '&.MuiLink-underlineHover:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
    },
  },
  navLinkHover: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  navTextHeader: {
    fontSize: 15,
  },
  navTextFooter: {
    fontSize: 14,
  },
  navLogin: {
    fontSize: 14,
    backgroundColor: '#C92A2A',
    letterSpacing: 1,
    borderRadius: 5,
    padding: '6px 52px',
    cursor: 'pointer',
  },
}))

export const NavigationDashboardTop: FC = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const handleClick = useCallback((href) => {
    window.open(href)
  }, [])

  const logOutHandler = useCallback(() => dispatch(logoutRequest()), [dispatch])

  return (
    <List component="nav" aria-label="main mailbox folders" className={classes.navHeader}>
      {navigationTabListHeader.map((navItem) => (
        <ListItem className={classes.navItem} key={navItem.name}>
          <Link
            href={!navItem.isWindowOpen ? navItem.path : '#'}
            onClick={navItem.isWindowOpen ? () => handleClick(navItem.path) : undefined}
            className={clsx(classes.navLink, classes.navTextHeader, classes.navLinkHover)}
          >
            {navItem.name}
          </Link>
        </ListItem>
      ))}

      <ListItem className={classes.navItem}>
        <Button className={clsx(classes.navTextHeader, classes.navLogin, classes.navLink)} onClick={logOutHandler}>
          Log Out
        </Button>
      </ListItem>
    </List>
  )
}

export const NavigationDashboardBottom: FC = () => {
  const classes = useStyles()

  const handleClick = useCallback((href) => {
    window.open(href)
  }, [])

  return (
    <List component="nav" aria-label="main mailbox folders" className={classes.navFooter}>
      {navigationTabListFooter.map((navItem) => (
        <ListItem className={classes.navItem} key={navItem.name}>
          <Button
            href={!navItem.isWindowOpen ? navItem.path : '#'}
            onClick={navItem.isWindowOpen ? () => handleClick(navItem.path) : undefined}
            className={clsx(classes.navLink, classes.navTextFooter)}
          >
            {navItem.name}
          </Button>
        </ListItem>
      ))}
    </List>
  )
}
